module.exports = __webpack_public_path__ + "static/media/result_codePost_exposedTests.63477da0.jpg";